module.exports = __webpack_public_path__ + "img/thank-img.d1095c20.png";